/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cut_TitleInputs */

const en_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cut Event/Text`)
};

const fr_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couper Evenement/Texte`)
};

const de_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis/Text ausschneiden`)
};

const it_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglia evento/testo`)
};

const ru_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вырезать событие/текст`)
};

const es_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cortar evento/texto`)
};

const zh_cn2_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剪切事件/文本`)
};

const ja_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント/テキストの切り取り`)
};

const hi_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट/टेक्स्ट को काटें`)
};

const pt_pt2_cut_title = /** @type {(inputs: Cut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar evento/texto`)
};

/**
* | output |
* | --- |
* | "Cut Event/Text" |
*
* @param {Cut_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cut_title = /** @type {((inputs?: Cut_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cut_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cut_title(inputs)
	if (locale === "de") return de_cut_title(inputs)
	if (locale === "it") return it_cut_title(inputs)
	if (locale === "ru") return ru_cut_title(inputs)
	if (locale === "es") return es_cut_title(inputs)
	if (locale === "zh-CN") return zh_cn2_cut_title(inputs)
	if (locale === "ja") return ja_cut_title(inputs)
	if (locale === "hi") return hi_cut_title(inputs)
	if (locale === "pt-PT") return pt_pt2_cut_title(inputs)
	return en_cut_title(inputs)
});